import { applyMiddleware, legacy_createStore } from 'redux'
//引入reducers
import reducers from './reducers/login_recuder'
//引入redux-thunk
import thunk from 'redux-thunk'
//映入
import { composeWithDevTools } from 'redux-devtools-extension'

const store = legacy_createStore(reducers, composeWithDevTools(applyMiddleware(thunk)))

export default store
